var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon-play",attrs:{"aria-hidden":"true","tabindex":"-1","role":"presentation","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"#ffffff","d":"M6.752,0.055l21.904,15.944L6.754,31.945"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }